import { render, staticRenderFns } from "./adverts-header.vue?vue&type=template&id=42d8406e"
import script from "./adverts-header.vue?vue&type=script&lang=ts"
export * from "./adverts-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports